export default "__VITE_ASSET__D6HKU6nx__"